<template>
  <div>
    <!-- タブ -->
    <div class="top-fv-search-tabs" role="tablist">
      <button
        type="button"
        class="top-fv-search-tab"
        :class="{ 'top-fv-search-tab--active': activeTab === 'keyword' }"
        role="tab"
        :aria-selected="activeTab === 'keyword'"
        @click="activeTab = 'keyword'"
      >
        <i class="material-icons top-fv-search-tab__icon" aria-hidden="true">search</i>
        <span class="top-fv-search-tab__text">キーワード<br class="top-fv-search-tab__br"><span class="top-fv-search-tab__sub">で探す</span></span>
      </button>
      <button
        type="button"
        class="top-fv-search-tab"
        :class="{ 'top-fv-search-tab--active': activeTab === 'consultation' }"
        role="tab"
        :aria-selected="activeTab === 'consultation'"
        @click="activeTab = 'consultation'"
      >
        <span class="top-fv-search-tab__new">NEW</span>
        <i class="material-icons top-fv-search-tab__icon" aria-hidden="true">edit_note</i>
        <span class="top-fv-search-tab__text">症状・相談文<br class="top-fv-search-tab__br"><span class="top-fv-search-tab__sub">で探す</span></span>
      </button>
    </div>

    <!-- キーワード検索パネル -->
    <div v-show="activeTab === 'keyword'" class="top-fv-search-panel">
      <pc-search />
      <sp-search />
    </div>

    <!-- 相談文検索パネル -->
    <div v-show="activeTab === 'consultation'" class="top-fv-search-panel">
      <textarea
        v-model="consultationText"
        class="top-fv-consultation-textarea"
        placeholder="3歳の子どもが昨日の夜から38.5度の熱があります。今朝は少し下がって37.8度になりましたが、食欲がなく、ぐったりしています。咳や鼻水はありません。保育園で手足口病が流行っていると聞きました。すぐに病院に連れて行くべきでしょうか？それとも様子を見ても大丈夫でしょうか？"
        rows="4"
        :maxlength="maxQueryLength"
      ></textarea>
      <button
        type="button"
        class="top-fv-consultation-btn"
        :disabled="!consultationText.trim()"
        @click="openSimilarSearch"
      >
        検索する
      </button>
    </div>

    <!-- かんたん検索モーダル -->
    <similar-search-dialog
      :visible="isDialogOpen"
      :initial-query="consultationText"
      @query-input="consultationText = $event"
      @close="isDialogOpen = false"
    />
  </div>
</template>

<script>
import PcSearch from './pc/Search';
import SpSearch from './sp/Search';
import SimilarSearchDialog from '../similar_search/components/SimilarSearchDialog.vue';
import { trackSimilarSearch } from '../similar_search/tracking';
import { VALIDATION } from '../similar_search/types';

export default {
  components: { PcSearch, SpSearch, SimilarSearchDialog },
  data() {
    return {
      activeTab: 'keyword',
      consultationText: '',
      isDialogOpen: false,
      maxQueryLength: VALIDATION.MAX_QUERY_LENGTH
    };
  },
  watch: {
    activeTab(val) {
      const fvSearch = this.$el.closest('.top-fv-search');
      if (fvSearch) {
        fvSearch.classList.toggle('top-fv-search--consultation', val === 'consultation');
      }
      if (val === 'consultation') {
        trackSimilarSearch('switch', '症状相談文タブ');
      }
    }
  },
  methods: {
    openSimilarSearch() {
      if (this.consultationText.trim()) {
        trackSimilarSearch('click', '検索ボタン_TOP');
        this.isDialogOpen = true;
      }
    }
  }
};
</script>
